export default __webpack_public_path__ + "static/media/asseto-corsa-competitzione.f44026f5.png";